import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchRatings } from "../../../api/statisticsApi";  

// Custom hook to fetch sensor ratings data
function useFetchRatings() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        fetchRatings().then((data) => {
            if (data?.length > 0) {
                const processedData = processRatingsData(data);
                setData(processedData);
            }
            }).catch((err) => {
            console.log(err)
            toast.error("Cannot Fetch Sensor Data");
            setError(err);
            }).finally(() => {
            setLoading(false);
            });
    }, [])

    return { data, loading, error };
}

const processRatingsData = (data) => {
    let greenCount = 0;
    let amberCount = 0;
    let redCount = 0;
    let neutralCount = 0;

    const set = new Set();
    data.forEach(item => {
        set.add(item.site);
        const rating = item.rating;
        const count = item.number;

        switch (rating) {
            case 'GOOD':
                greenCount += count;
                break;
            case 'FAIR':
                amberCount += count;
                break;
            case 'POOR':
                redCount += count;
                break;
            case 'NA':
                neutralCount += count;
                break;
            default:
                console.warn(`Unexpected rating: ${rating}`);
                break;
        }
    });
    return { isAdmin: set.size > 1, greenCount, amberCount, redCount, neutralCount };
}



export default useFetchRatings;